import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DurationFormatService {
  private readonly durationThresholds = [
    {
      limit: 60 * 60 * 1000,
      format: (ms: number) => `${Math.round(ms / 60_000)}min`
    },
    {
      limit: 24 * 60 * 60 * 1000,
      format: (ms: number) => {
        const h = Math.floor(ms / 3_600_000);
        const m = Math.round((ms % 3_600_000) / 60_000);
        return m === 0 ? `${h}h` : `${h}h${m}min`;
      }
    },
    {
      limit: Infinity,
      format: (ms: number) => {
        const d = Math.floor(ms / 86_400_000);
        return `${d} ${d === 1 ? 'dia' : 'dias'}`;
      }
    }
  ];

  formatFromHours(hours: number): string {
    return this.formatTime(this.toMilliseconds(hours));
  }

  private toMilliseconds(hours: number): number {
    return Number.isFinite(hours) ? Math.max(0, hours * 3_600_000) : 0;
  }

  private formatTime(ms: number): string {
    if (ms <= 0) return '--';
    return this.durationThresholds.find(({ limit }) => ms < limit)!.format(ms);
  }
}
